module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cmVjdCByeD0iMCIgcnk9IjAiIGhlaWdodD0iNDc3LjkiIHdpZHRoPSI2NDAiLz4KICAgIDxyZWN0IHJ4PSIwIiByeT0iMCIgaGVpZ2h0PSIxNTkuMyIgd2lkdGg9IjY0MCIgeT0iMzIwLjciIGZpbGw9IiNmZmYiLz4KICAgIDxwYXRoIGZpbGw9IiMxMjkxZmYiIGQ9Ik0wIDBoNjQwdjE1OS4zSDB6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/ee.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/ee.svg
// module chunks = 0